module.exports = __webpack_public_path__ + "img/20200609_133242.f41f7471.jpg";